import React, { FC } from 'react';
import classNames from 'classnames/bind';
import { Text } from '@beef/ui-kit';
import { getLocalCurrencyStr } from '@beef/utils';

import { TooltipWrapper } from '../Period/components/TooltipWrapper';
import { StrikePriceProps } from './types';
import styles from './styles.pcss';

const cn = classNames.bind(styles);

export const StrikePrice: FC<StrikePriceProps> = ({ price, toolTip }) => {
  if (!price) return null;

  return (
    <div className={cn('component', 'mar-l-3xs')}>
      <Text className={cn('price')} color="grey60" size="size5-r-s">
        {getLocalCurrencyStr(price)}
      </Text>
      {toolTip && (
        <div className={cn('tooltip', 'mar-l-3xs')}>
          <TooltipWrapper message={toolTip} />
        </div>
      )}
    </div>
  );
};
